import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "append-filters__container q-container-fluid q-pb-2 q-col-12 q-d-block q-d-lg-none q-px-3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "q-spinner-border q-spinner-border-sm q-ms-2",
  role: "status",
  "aria-hidden": "true"
}

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {inject} from 'vue';
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppendFiltersButton',
  setup(__props) {

const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const serpStore = useSerpResultsStore()

const {isLoading} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const {loading: productIsLoading} = storeToRefs(serpStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

const appendFilters = () => {
  filtersStore.hideFiltersOnMobile()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm",
      onClick: appendFilters,
      disabled: _unref(isLoading)
    }, [
      _createElementVNode("span", null, _toDisplayString(_unref(SmartSearchTranslations).autocomplete.seeMore), 1),
      (_unref(isLoading) || (_unref(productIsLoading) && _unref(isMobileView)))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _withDirectives((_openBlock(), _createElementBlock("span", { key: 1 }, " (" + _toDisplayString(_unref(serpStore).getTotalProducts) + ")", 513)), [
            [_vShow, _unref(serpStore).getTotalProducts]
          ])
    ], 8, _hoisted_2)
  ]))
}
}

})